import { render, staticRenderFns } from "./DesktopReport.vue?vue&type=template&id=4dd43bf7&scoped=true&"
import script from "./DesktopReport.vue?vue&type=script&lang=js&"
export * from "./DesktopReport.vue?vue&type=script&lang=js&"
import style0 from "./DesktopReport.vue?vue&type=style&index=0&id=4dd43bf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd43bf7",
  null
  
)

export default component.exports